<template>
  <img class="inline-block w-64" src="/assets/images/logo-b.svg" width="484" height="100" :alt="$t('header.logo_alt')">
</template>
